var nurseslounge_degree_reviews = {
    init:function($params, cback){
        $params = $.extend({},$params, {
            user_id:libs.memoryGet('user_id'),
            tab:'review_init'
        });
        nurseslounge_degree_reviews.reviews_get($params, function($data){
            nurseslounge_degree_reviews.reviews_rating($params, $data);
            if(cback != undefined){
                cback();
            }
        });
        nurseslounge_degree_reviews.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    reviews_get:function($params, cback){
        $.ajax({
            url: "/degree/reviews/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-review-modal").modal('hide');
                    $("#nurseslounge-degree-review-answer-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    reviews_rating:function($params, $data){
        var $nursesloungeDegreeReview = $("#nurseslounge-degree-reviews");
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $degreeReviewsRight = $nursesloungeDegreeReview.find('.nurseslounge-degree-reviews-right:first');
        var $ratingFirst = $degreeReviewsRight.find('.rating-stars:first');
        var $ratingCount = $degreeReviewsRight.find('.rating-count:first');
        var $addReviewFirst = $degreeReviewsRight.find('.add-review:first');
        var $deleteReviewFirst = $degreeReviewsRight.find('.delete-review:first');
        $ratingFirst.unbind().click(function(){
            nurseslounge_degree_information.information_review($params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_degree_reviews.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $ratingCount.unbind().click(function(){
            nurseslounge_degree_information.information_review($params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_degree_reviews.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $addReviewFirst.unbind().click(function(){
            nurseslounge_degree_information.information_review($params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_degree_reviews.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $deleteReviewFirst.unbind().click(function(){
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_degree_information.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_degree_reviews.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
        nurseslounge_degree_reviews.reviews_rating_list($params);
    },
    reviews_rating_list:function($params){
        var $loungeReviewsLeft = $("#nurseslounge-degree-reviews .nurseslounge-degree-reviews-left");
        var $commentsList = $loungeReviewsLeft.find(".comments-list:first");
        var $commentsListPreview = nurseslounge_degree_reviews.comments_preview();
        var $resultInfo = $loungeReviewsLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $loungeReviewsLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $resultInfo.addClass('nurseslounge-degree-reviews-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-degree-reviews-preload').html($paginationNavPreview);
        $commentsList.html($commentsListPreview).promise().done(function(){
            nurseslounge_degree_reviews.reviews_rating_pagination($params);
        });
    },
    comments_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white preview rounded">' +
                '    <div class="row pb-4 border-bottom">' +
                '        <div class="col-12 align-self-center">' +
                '            <div class="row d-flex">' +
                '                <div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       Degree Title' +
                '                    </label>' +
                '                    <p class="nurseslounge-degree-reviews-preload">&nbsp;</p>' +
                '                </div>' +
                '                <div class="col-12 col-md-auto pb-2 pb-sm-0">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       Location' +
                '                    </label>' +
                '                    <p class="nurseslounge-degree-reviews-preload">&nbsp;</p>' +
                '                </div>' +
                '                <div class="col-12 col-md-auto pb-2 pb-sm-0">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       Recommends this Degree?' +
                '                    </label>' +
                '                    <p class="nurseslounge-degree-reviews-preload">&nbsp;</p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row mt-3">' +
                '        <div class="col-sm">' +
                '            <div class="font-weight-bold mb-2">' +
                '               Review' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-auto">' +
                '            <div class="clg-rating d-flex">' +
                '                <div class="rating-count align-self-center mr-2 nurseslounge-degree-reviews-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="rating-stars align-self-center mt-n2">' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row">' +
                '        <div class="col-sm-12 mb-2">' +
                '            <div class="review-desc bg-light p-4">' +
                '                <h5 class="nurseslounge-degree-reviews-preload">&nbsp;</h5>' +
                '                <p class="nurseslounge-degree-reviews-preload">&nbsp;</p>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-12 mb-2">' +
                '            <div class="review-desc bg-light p-4">' +
                '                <h5 class="nurseslounge-degree-reviews-preload">&nbsp;</h5>' +
                '                <p class="nurseslounge-degree-reviews-preload">&nbsp;</p>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    reviews_rating_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $loungeReviewsLeft = $("#nurseslounge-degree-reviews .nurseslounge-degree-reviews-left");
        var $commentsList = $loungeReviewsLeft.find('.comments-list:first');
        var $paginationNav = $loungeReviewsLeft.find('.pagination-nav:first');
        var $previewHeight = $loungeReviewsLeft.find('.comments-list .preview:first').innerHeight();
        var $commentsHeight = $commentsList.innerHeight();
        var $pageSize = Math.round(($commentsHeight/$previewHeight));
        var $resultInfo = $loungeReviewsLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        var $userCredential;
        try{
            $paginationObj = libs.memoryGet('reviews_rating_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/degree/reviews/get",
            locator: 'data.reviews',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$.extend({}, $params, {tab:'reviews_list'}),
                beforeSend: function() {
                    $commentsList.html(nurseslounge_degree_reviews.comments_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                    if($data.responseJSON.status == 'error'){
                        $("#nurseslounge-degree-information-review-modal").modal('hide');
                        $("#nurseslounge-degree-review-answer-modal").modal('hide');
                    }
                }
            },
            totalNumberLocator: function($data) {
                $userCredential = $data.data.user_credential.map(function($x){return parseInt($x);});
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                if($commentsList.length > 0 && $commentsList.offset().top && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$commentsList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-degree-reviews-preload');
                $resultInfo.removeClass('nurseslounge-degree-reviews-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Reviews</span>');
                var $chtml = nurseslounge_degree_reviews.item_html($data, $userCredential);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $commentsList.html('').html($chtml).promise().done(function () {
                        nurseslounge_degree_reviews.list_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('reviews_rating_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_degree_reviews.reviews_rating_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    item_html:function($reviews, $userCredential){
        var $chtml = '';
        $.each($reviews, function($i, $v){
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded" data-key="'+$v.key+'">' +
                '    <div class="row pb-4 border-bottom">' +
                '        <div class="col-12 align-self-center">' +
                '            <div class="row d-flex">';
                if($userCredential && $.inArray(21, $userCredential) != -1) {
                    $chtml+='' +
                        '<div class="col-12">' +
                        '    <img src="/bimg/NursesLounge/more-horizontal-back.png" alt="horizontal dots" class="pull-right answer-review">' +
                        '</div>';
                }
            $chtml+='' +
                '                <div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       Degree Title' +
                '                    </label>' +
                '                    <p>'+$v.degree_program+'</p>' +
                '                </div>' +
                '                <div class="col-12 col-md-4 pb-2 pb-sm-0">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       Location' +
                '                    </label>' +
                '                    <p>'+$v.location.replace('_', ' ')+'</p>' +
                '                </div>' +
                '                <div class="col-12 col-md-4 pb-2 pb-sm-0">';
                if($v.recommend_to_friend == 'yes'){
                    $chtml+='' +
                        '<div class="row">' +
                        '   <div class="col-8 offset-4 mt-3">' +
                        '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                        '   </div>' +
                        '</div>';
                }
            $chtml+='' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row mt-3">' +
                '        <div class="col-sm">' +
                '            <div class="font-weight-bold mb-2">' +
                '               Review' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-auto">' +
                '            <div class="clg-rating d-flex">' +
                '                <div class="rating-count align-self-center mr-2 ">' +
                $v.overall_rating + ' / 5' +
                '                </div>' +
                '                <div class="rating-stars align-self-center mt-n2">' +
                nurseslounge_degree_reviews.add_stars($v.overall_rating) +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row">';
            if($v.pros && $v.pros != '') {
                $chtml += '' +
                    '        <div class="col-sm-12 mb-2">' +
                    '            <div class="pros review-desc bg-light p-4">' +
                    '                <h5>Pros</h5>' +
                    '                <p>' + $v.pros + '</p>' +
                    '            </div>' +
                    '        </div>';
            }
            if($v.cons && $v.cons != '') {
                $chtml += '' +
                    '        <div class="col-sm-12 mb-2">' +
                    '            <div class="review-desc bg-light p-4">' +
                    '               <h5>Cons</h5>' +
                    '               <p>' + $v.cons + '</p>' +
                    '            </div>' +
                    '        </div>';
            }
            $chtml+='' +
                '    </div>';

            if($v.answer) {
                $chtml += '' +
                    '<div class="row border-top mt-3">' +
                    '  <div class="col-sm-12">' +
                    '    <div class="result-info-count pt-3">Response from ' +
                    '       <span class="link-color font-weight-bold open-url" data-url="'+$v.answer.user.profile_url+'">' +
                    $v.answer.user.long_name +
                    '       </span>' +
                    '    </div>' +
                    '    <div class="contact-header link-color font-weight-normal">' +
                    '      <p>' +
                    $v.answer.answer +
                    '      </p>' +
                    '    </div>' +
                    '  </div>' +
                    '</div>';
            }

            $chtml+='' +
                '</li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    list_events:function($params){
        var $loungeReviewsLeft = $("#nurseslounge-degree-reviews .nurseslounge-degree-reviews-left");
        var $commentsList = $loungeReviewsLeft.find('.comments-list:first');
        $commentsList.find('.answer-review').unbind().click(function(){
            var $key = $(this).parents('li:first').data('key');
            nurseslounge_degree_reviews.reviews_edit_review($params, $key);
        });
        $commentsList.find('.open-url').unbind().click(function(){
            var $url = $(this).data('url');
            window.open($url,'_blank');
        });
    },
    reviews_edit_review:function($params, $reviewKey){
        $params = $.extend({},$params,{
            user_id:libs.memoryGet('user_id'),
            review_key:$reviewKey,
            tab:'review'
        });
        var $modal = $("#nurseslounge-degree-review-answer-modal");
        var $modalInfo = $modal.find('.modal-info');
        nurseslounge_degree_reviews.reviews_get($params, function($data){
            var $modalInfoContent = nurseslounge_degree_reviews.item_popup_html($data);
            $modalInfo.html($modalInfoContent).promise().done(function () {
                nurseslounge_degree_reviews.reviews_popup_events($params, $data, function () {
                    $modal.modal('show');
                });
            });
        });
    },
    item_popup_html:function($data){
        var $review = $data.data.review;
        var $chtml = '';
        $chtml+='' +
            '<div class="row">' +
            '    <div class="col-sm-6">' +
            '        <div>' +
            '            Written by' +
            '            <span class="link-color font-weight-bold open-url" data-url="'+$review.user.profile_url+'">'+$review.user.long_name+'</span>' +
            '        </div>' +
            '    </div>' +
            '    <div class="col-sm-6 text-sm-right">' +
            '        <div class="text-muted">'+$review.date+'</div>' +
            '    </div>' +
            '    <div class="col-sm-12">' +
            '        <div class="pt-4 mb-3 bg-white rounded">' +
            '            <div class="row pb-2">' +
            '                <div class="col-12 align-self-center">' +
            '                    <div class="row d-flex">' +
            '                        <div class="col-12 col-md-4 rating-title pb-2 pb-sm-0">' +
            '                            <label class="text-muted font-weight-normal mb-0">' +
            '                               Degree Title' +
            '                            </label>' +
            '                            <p>'+$review.degree_program+'</p>' +
            '                        </div>' +
            '                        <div class="col-12 col-md-4 rating-title pb-2 pb-sm-0">' +
            '                            <label class="text-muted font-weight-normal mb-0">' +
            '                               Location' +
            '                            </label>' +
            '                            <p>'+$review.location.replace('_',' ')+'</p>' +
            '                        </div>' +
            '                        <div class="col-12 col-md-4 rating-title pb-2 pb-sm-0">';
            if($review.recommend_to_friend == 'yes'){
                $chtml+='' +
                    '<div class="row">' +
                    '   <div class="col-8 offset-4 mt-3">' +
                    '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                    '   </div>' +
                    '</div>';
            }
        $chtml+='' +
            '                        </div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="row mt-2">' +
            '                <div class="col-sm">' +
            '                    <div class="font-weight-bold mb-2">' +
            '                       Review' +
            '                    </div>' +
            '                </div>' +
            '                <div class="col-sm-auto">' +
            '                    <div class="clg-rating d-flex">' +
            '                        <div class="rating-count align-self-center mr-2">' +
            $review.overall_rating + ' / 5' +
            '                        </div>' +
            '                        <div class="rating-stars align-self-center mt-n2">' +
            nurseslounge_degree_reviews.add_stars($review.overall_rating) +
            '                        </div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="row">';
            if($review.pros && $review.pros != '') {
                $chtml += '' +
                    '                <div class="col-sm-12 mb-2">' +
                    '                    <div class="review-desc bg-light p-4">' +
                    '                        <h5>Pros</h5>' +
                    '                        <p>' + $review.pros + '</p>' +
                    '                    </div>' +
                    '                </div>';
            }
            if($review.cons && $review.cons != '') {
                $chtml += '' +
                    '                <div class="col-sm-12 mb-2">' +
                    '                    <div class="review-desc bg-light p-4">' +
                    '                        <h5>Cons</h5>' +
                    '                        <p>' + $review.cons + '</p>' +
                    '                    </div>' +
                    '                </div>';
            }
        $chtml+='' +
            '            </div>' +
            '            <div class="row border-top mt-3">' +
            '                <div class="col-sm-12">';
            if($review && $review.answer) {
                $chtml += '' +
                    '<div class="result-info-count pt-3">' +
                    '    Response from' +
                    '    <span class="link-color font-weight-bold open-url" data-url="'+$review.answer.user.profile_url+'">' +
                    $review.answer.user.long_name +
                    '    </span>' +
                    '</div>';
            }
        $chtml+='' +
            '                    <div class="mt-2 font-weight-normal">' +
            '                        <div class="form-group">' +
            '                            <textarea class="form-control" name="answer" placeholder="Type Response Here...">';
            if($review && $review.answer && $review.answer.answer){
                $chtml+=$review.answer.answer;
            }
        $chtml+='</textarea>' +
            '                        </div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '    <div class="col-sm-12 text-right py-3">' +
            '        <button type="button" class="btn btn-save btnAnimate mb-2 option" data-action="delete review">Delete Review</button>' +
            '        <button type="button" class="btn btn-save btnAnimate mb-2 option" data-action="delete answer">Delete Answer</button>' +
            '        <button type="button" class="btn btn-save btnAnimate mb-2 option" data-action="save">Save</button>' +
            '    </div>' +
            '</div>';

        return $chtml;
    },
    reviews_popup_events:function($params, $data, cback){
        var $modal = $("#nurseslounge-degree-review-answer-modal");
        var $answer = $modal.find('textarea[name="answer"]');
        $modal.find('.option').unbind().click(function(){
            var $that = $(this);
            var $action = $that.data('action');
            $params = $.extend({},$params, {action:$action,answer:$answer.val()});
            nurseslounge_degree_reviews.review_answer_set($params, function($data) {
                switch($action){
                    case 'delete review':
                        libs.refreshBoxFrom('.review-box', $params, function () {
                            nurseslounge_degree_reviews.init($params, function(){
                                $modal.modal('hide');
                            });
                        });
                        break;
                    case 'delete answer':
                        nurseslounge_degree_reviews.init($params, function(){
                            $modal.modal('hide');
                        });
                        break;
                    case 'save':
                        nurseslounge_degree_reviews.init($params, function(){
                            $modal.modal('hide');
                        });
                        break;
                }
            });
        });
        $modal.find('.open-url').unbind().click(function(){
            var $url = $(this).data('url');
            window.open($url,'_blank');
        });
        if(cback != undefined){
            cback();
        }
    },
    review_answer_set:function($params, cback){
        $.ajax({
            url: "/degree/review/answer/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-review-modal").modal('hide');
                    $("#nurseslounge-degree-review-answer-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-degree-reviews .nurseslounge-degree-reviews-right .banners")
        });
    },
};
